'use client'

import Link from 'next/link'
import type { ComponentProps } from 'react'
import { useFiltersStore } from '@/lib/store/filters-store'
import { withListingFilters } from '@/lib/filters/listing-navigation'
import { cancelGridNavigationTransition } from '@/lib/assets/grid-navigation-transition'
import { startAssetsGridTransition } from '@/lib/hooks/use-assets-grid-transition'

export function useCategoryHref() {
  const filters = useFiltersStore((state) => state.filters)
  return (href: string) => withListingFilters(href, filters)
}

export default function CategoryLink({
  href,
  animateTransition = true,
  ...props
}: Omit<ComponentProps<typeof Link>, 'href'> & { href: string; animateTransition?: boolean }) {
  const hrefFor = useCategoryHref()
  const { onClick, ...linkProps } = props
  return (
    <Link
      {...linkProps}
      href={hrefFor(href)}
      onClick={(event) => {
        onClick?.(event)
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return
        }
        if (animateTransition) startAssetsGridTransition(event.currentTarget.href)
        else cancelGridNavigationTransition()
      }}
    />
  )
}
